import React, { Component } from "react";
import Content from "../../content/Content";
import Store from "../../content/Store";
import ClaimNumberValidation from "./../../validations/ClaimNumberValidation";
import TabbedNavigation from "../../components/shared/TabbedNavigation";
import PrepareConsent from "./PrepareConsent";
import ProvideMedicalConsent from "./ProvideMedicalConsent";
import ProvideEmergencyConsent from "./ProvideEmergencyConsent";
import ProvideDeclaration from "./ProvideDeclaration";
import TermsAndConditions from "./TermsAndConditions";
import { Layouts } from "../../constants/Constants";
import { connect } from "react-redux";
import { submitMedicalConsent } from "../../services/MedicalConsent";
import MedicalConsentConfirmation from "./MedicalConsentConfirmation";
import { Paths } from "../../constants/UrlConstants";
import { stateToModel } from "./MedicalConsentApiMapper";
import MemberHelper from "../../helpers/MemberHelper";
import { isFieldDefined } from "../../validations/RequiredFieldValidator";
import AddressHelper from "./../../helpers/AddressHelper";
import styles from "../../assets/css/modules/medicalconsent/medicalconsent.css";
import { redirectToErrorPageMessage } from "../../logging/CommonLogMessages";
import { trackException } from "../../logging/AppInsightsLogger";

export const mapStateToMedicalConsent = (state) => {
  var member = state.policyReducer.selectedPolicy.Members.find(
    (mem) => mem.IsPolicyHolder
  );

  let loggedInMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    state.policyReducer.selectedPolicy
  );

  return {
    layout: state.layoutReducer.layout,
    isFormat2: state.policyReducer.selectedPolicy.IsFormat2,
    fullName: state.layoutReducer.layout === Layouts.MOL ? member.FullName : "",
    address:
      state.layoutReducer.layout === Layouts.MOL
        ? AddressHelper.getAddressAsNewLineString(member.Address, false)
        : "",
    membershipNumber: state.policyReducer.selectedPolicy.MembershipNumber,
    phoneNumber: !state.policyReducer.selectedPolicy.IsFormat2
      ? loggedInMember.PhoneNumbers &&
        loggedInMember.PhoneNumbers[0] &&
        loggedInMember.PhoneNumbers[0].Number
      : "",
    emailAddress: state.policyReducer.policyDetails.UserName,
    loggedInMemberFullName: loggedInMember.FullName
  };
};

class MedicalConsent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      claimToolTipVisible: false,
      validationErrors: [],
      tabs: [
        { title: Store.MedicalConsent.Title1, isActive: true },
        {
          title: <Content name={Store.MedicalConsent.Title2} />,
          isActive: false
        },
        { title: Store.MedicalConsent.Title3, isActive: false },
        { title: Store.MedicalConsent.Title4, isActive: false },
        { title: Store.MedicalConsent.Title5, isActive: false }
      ],
      prepareConsentHasError: false,
      showConfirmation: false,
      medicalConsent: {
        claimNumber: "",
        fullName: props.fullName,
        address: props.address,
        membershipNumber: props.membershipNumber,
        phoneNumber: props.phoneNumber,
        emailAddress: props.emailAddress,
        areYouHavingTreatment: "",
        isTheTreatmentNeeded: "",
        doYouHaveOtherPolicies: "",
        otherInsuranceCompanyName: "",
        otherInsuranceCompanyAddress: "",
        otherPolicyNumber: "",
        loggedInUserFullName: props.loggedInMemberFullName,
        patientName: "",
        relationshipToPatient: "",
        assessAndReview: "",
        auditHealthcare: "",
        iAmThePatient: "",
        isPatientUnder16: "",
        isPatientsParent: "",
        seeReport: "",
        acceptTermsAndConditions: ""
      }
    };
    this.goBack = this.goBack.bind(this);
    this.proceedToNextTab = this.proceedToNextTab.bind(this);
    this.goBackToPreviousTab = this.goBackToPreviousTab.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  validateClaimNumberErrors() {
    if (!isFieldDefined(this.state.medicalConsent.claimNumber)) {
      return Store.MedicalConsent.ValidationErrors.ClaimNumberRequiredFields;
    } else if (
      !ClaimNumberValidation(
        this.state.medicalConsent.claimNumber,
        this.props.isFormat2
      )
    ) {
      return Store.MedicalConsent.ValidationErrors.ClaimNumberInvalidFormat;
    }
    return;
  }

  proceedToNextTab(event) {
    event.preventDefault();
    let errorMessages = [];

    if (this.state.tabs[0].isActive) {
      if (this.validateClaimNumberErrors()) {
        errorMessages.push(this.validateClaimNumberErrors());
      }
    }

    this.setState({
      validationErrors: errorMessages,
      prepareConsentHasError: errorMessages.length > 0
    });
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (errorMessages.length === 0) {
      this.changeActiveTab(this.getNextTab());
    }
  }

  getNextTab() {
    return this.state.tabs.findIndex((tab) => tab.isActive) + 1;
  }

  getPreviousTab() {
    return this.state.tabs.findIndex((tab) => tab.isActive) - 1;
  }

  changeActiveTab(index) {
    let tabs = [
      { title: Store.MedicalConsent.Title1, isActive: false },
      {
        title: <Content name={Store.MedicalConsent.Title2} />,
        isActive: false
      },
      { title: Store.MedicalConsent.Title3, isActive: false },
      { title: Store.MedicalConsent.Title4, isActive: false },
      { title: Store.MedicalConsent.Title5, isActive: false }
    ];
    tabs[index].isActive = true;

    this.setState({
      tabs: tabs
    });
  }

  goBack(event) {
    event.preventDefault();
    this.props.history.goBack();
  }

  goBackToPreviousTab(event) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.changeActiveTab(this.getPreviousTab());
  }

  onChange(event) {
    if (event && event.target && typeof event.target.name === "string") {
      let newMedicalConsent = Object.assign({}, this.state.medicalConsent);
      newMedicalConsent[event.target.name] = event.target.value;
      if (this.isThePatient(event)) {
        this.resetPatientDetailsInNewMedicalConsent(newMedicalConsent);
      } else if (
        event.target.name === "doYouHaveOtherPolicies" &&
        event.target.value === "no"
      ) {
        newMedicalConsent.otherInsuranceCompanyName = "";
        newMedicalConsent.otherInsuranceCompanyAddress = "";
        newMedicalConsent.otherPolicyNumber = "";
      }
      this.setState({ medicalConsent: newMedicalConsent });
    }
  }

  onSubmit(event) {
    event.preventDefault();
    const apiRequestModel = stateToModel(this.state.medicalConsent);

    submitMedicalConsent(apiRequestModel).then((response) => {
      if (response.status && response.status === 200) {
        this.setState({ showConfirmation: true });
      } else {
        trackException(
          redirectToErrorPageMessage,
          `Something went wrong while submitting medical consent. ResponseStatus: ${
            response.status
          } MembershipNumber:${
            this.state.medicalConsent &&
            this.state.medicalConsent.membershipNumber
          }`
        );
        this.props.history.push(Paths.Error);
      }
    });
  }

  isThePatient(event) {
    return (
      event.target.name === "iAmThePatient" && event.target.value === "yes"
    );
  }

  resetPatientDetailsInNewMedicalConsent(medicalConsent) {
    medicalConsent.isPatientUnder16 = "";
    medicalConsent.isPatientsParent = "";
    medicalConsent.relationshipToPatient = "";
    medicalConsent.patientName = "";
  }

  render() {
    if (this.state.showConfirmation) {
      return (
        <MedicalConsentConfirmation
          claimNumber={this.state.medicalConsent.claimNumber}
        />
      );
    }

    return (
      <React.Fragment>
        <TabbedNavigation tabs={this.state.tabs} />
        <div className={styles.medicalConsent + " container"}>
          <div className="row">
            <div className="col-md-6 offset-md-3">
              {this.state.tabs[0].isActive ? (
                <PrepareConsent
                  pageTitle={
                    <Content
                      name={
                        Store.MedicalConsent.MedicalConsentClaimInput.PageTitle
                      }
                    />
                  }
                  medicalConsent={this.state.medicalConsent}
                  pageBody={
                    <Content
                      name={Store.MedicalConsent.MedicalConsentClaimInput.Body}
                    />
                  }
                  errorValidationHeading={
                    <Content name={Store.GeneralPages.CorrectErrors} />
                  }
                  errors={this.state.validationErrors}
                  prepareConsentOnSubmit={this.proceedToNextTab}
                  prepareConsentHasError={this.state.prepareConsentHasError}
                  inputId="claimNumber"
                  autoComplete="off"
                  prepareConsentInputLabel={
                    <Content
                      name={Store.MedicalConsent.MedicalConsentClaimInput.Label}
                    />
                  }
                  prepareConsentOnInputFieldChange={this.onChange}
                  goBack={this.goBack}
                  buttonBackText={
                    <Content name={Store.GeneralPages.ButtonBackText} />
                  }
                  nextButton={<Content name="Next" />}
                />
              ) : this.state.tabs[1].isActive ? (
                <ProvideMedicalConsent
                  pageTitle={
                    <Content
                      name={Store.MedicalConsent.MemberDetailsPageTitle}
                    />
                  }
                  pageBody={
                    <Content
                      name={
                        Store.MedicalConsent.ProvideMedicalConsentInput.Body
                      }
                    />
                  }
                  errorValidationHeading={
                    <Content name={Store.GeneralPages.CorrectErrors} />
                  }
                  provideMemberdetailsOnSubmit={this.proceedToNextTab}
                  onChange={this.onChange}
                  errors={this.state.validationErrors}
                  medicalConsent={this.state.medicalConsent}
                  isAxaLayout={this.props.layout === Layouts.MOL}
                  isFormat2={this.props.isFormat2}
                  buttonBackText={
                    <Content name={Store.GeneralPages.ButtonBackText} />
                  }
                  previousContentHandleBackClick={(event) =>
                    this.goBackToPreviousTab(event)
                  }
                  nextButton={<Content name="Next" />}
                  provideMemberDetailsHasError={
                    this.state.prepareConsentHasError
                  }
                />
              ) : this.state.tabs[2].isActive ? (
                <ProvideEmergencyConsent
                  onChange={this.onChange}
                  pageTitle={
                    <Content
                      name={
                        Store.MedicalConsent.ProvideEmergencyConsentPageTitle
                      }
                    />
                  }
                  errorValidationHeading={
                    <Content name={Store.GeneralPages.CorrectErrors} />
                  }
                  pageBody={
                    <Content
                      name={
                        Store.MedicalConsent.ProvideEmergencyConsentPageBody
                      }
                    />
                  }
                  provideEmergencyConsentOnSubmit={this.proceedToNextTab}
                  previousContentHandleBackClick={(event) =>
                    this.goBackToPreviousTab(event)
                  }
                  buttonBackText={
                    <Content name={Store.GeneralPages.ButtonBackText} />
                  }
                  nextButton={<Content name="Next" />}
                  medicalConsent={this.state.medicalConsent}
                />
              ) : this.state.tabs[3].isActive ? (
                <ProvideDeclaration
                  medicalConsent={this.state.medicalConsent}
                  provideDeclarationOnSubmit={this.proceedToNextTab}
                  previousContentHandleBackClick={(event) =>
                    this.goBackToPreviousTab(event)
                  }
                  buttonBackText={
                    <Content name={Store.GeneralPages.ButtonBackText} />
                  }
                  nextButton={<Content name="Next" />}
                  onChange={this.onChange}
                  errorValidationHeading={
                    <Content name={Store.GeneralPages.CorrectErrors} />
                  }
                  isAxaLayout={this.props.layout === Layouts.MOL}
                />
              ) : (
                <TermsAndConditions
                  previousContentHandleBackClick={(event) =>
                    this.goBackToPreviousTab(event)
                  }
                  buttonBackText={
                    <Content name={Store.GeneralPages.ButtonBackText} />
                  }
                  onChange={this.onChange}
                  medicalConsent={this.state.medicalConsent}
                  onSubmit={this.onSubmit}
                  errorValidationHeading={
                    <Content name={Store.GeneralPages.CorrectErrors} />
                  }
                  submitButton="submit"
                />
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToMedicalConsent)(MedicalConsent);
